import { RadioCard } from "./RadioCard"
import styles from "./styles.module.scss"
import { Accordion, FormItem, Title } from "@vkontakte/vkui"
import { useUnit } from "effector-react"
import { FC, useEffect, useState } from "react"
import { $secondStageVotes, setSecondStageVote } from "src/entity/Pretendents"
import { $accordionTap, accordionEvent } from "src/entity/Pretendents/model/Pretendents"
import { INominee, TSecondStageBlockProps } from "src/entity/Pretendents/model/types"
import default_image from "src/shared/assets/images/default_image.svg"
import { MAP_LABEL_NOMINANTS } from "src/shared/config"

export const SecondStageBlock: FC<TSecondStageBlockProps> = ({ nominantData, id }) => {
  const { votes, addVote } = useUnit({
    votes: $secondStageVotes,
    addVote: setSecondStageVote,
  })

  const { accordEv } = useUnit({ accordEv: accordionEvent })

  const [openedAccordion, setOpenedAccordion] = useState(false)

  const onSelectedCard = (el: INominee) => {
    addVote({ [nominantData.name]: el.nomineeId })
  }

  const onToggleAccordion = (e: any) => {
    e.nativeEvent.newState === "open" ? setOpenedAccordion(true) : setOpenedAccordion(false)
    accordEv()
  }

  const iconAccordionClosed = () => (
    <svg
      className="vkuiIcon vkuiIcon--24 vkuiIcon--w-24 vkuiIcon--h-24 vkuiIcon--chevron_up_24 vkuiAccordionSummary__icon vkuiAccordionSummary__icon--expand"
      width="30"
      height="30"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 26.5H27M52 26.5H27M27 26.5V2M27 26.5V52" stroke="white" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
  const iconAccordionOpened = () => (
    <svg
      className="vkuiIcon vkuiIcon--24 vkuiIcon--w-24 vkuiIcon--h-24 vkuiIcon--chevron_down_24 vkuiAccordionSummary__icon vkuiAccordionSummary__icon--collapse"
      width="25"
      height="25"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.67588 1.96865L20.3536 19.6463M38.0312 37.324L20.3536 19.6463M20.3536 19.6463L37.6777 2.3222M20.3536 19.6463L2.32233 37.6775"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )

  useEffect(() => {
    if (typeof window === "undefined") return

    const mq = window.matchMedia("(max-width: 800px)")

    if (mq.matches) {
      if (id === 0) {
        setOpenedAccordion(true)
      } else {
        setOpenedAccordion(false)
      }
    } else {
      setOpenedAccordion(true)
    }

    // слушатель изменений
    const onChange = (e: MediaQueryListEvent) => {
      if (e.matches) {
        if (id === 0) {
          setOpenedAccordion(true)
        } else {
          setOpenedAccordion(false)
        }
      } else {
        setOpenedAccordion(true)
      }
    }

    // кросс-браузерная подписка
    if (mq.addEventListener) mq.addEventListener("change", onChange)
    else mq.addListener(onChange)

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange)
      else mq.removeListener(onChange)
    }
  }, [])

  return (
    <Accordion
      open={openedAccordion}
      className={styles.secondStageBlockWrapper}
      //   onClick={() => accordEv()}
      onToggle={onToggleAccordion}
    >
      <Accordion.Summary ExpandIcon={iconAccordionOpened} CollapseIcon={iconAccordionClosed}>
        <Title className={styles.title} weight="3" level="2">
          {nominantData.label || nominantData.name}
        </Title>
      </Accordion.Summary>

      <FormItem className={styles.form}>
        <div className={styles.content}>
          {nominantData.nominees.map((el: INominee) => (
            <RadioCard
              key={el.nomineeId}
              name={el.nomineeId}
              value={el.nomineeId}
              title={el.nomineeLabel}
              checked={votes ? votes[nominantData.name as keyof typeof votes] === el.nomineeId : false}
              image={el.image || default_image}
              onChange={() => onSelectedCard(el)}
            />
          ))}
        </div>
      </FormItem>
    </Accordion>
  )
}
